import React from 'react';
import { Outlet } from 'react-router-dom';
import DashboardSidebar from '../components/DashboardSidebar';

const DashboardLayout = () => {
  return (
    <div className="min-h-screen bg-dark-900 text-gray-100">
      <DashboardSidebar />
      <main className="md:ml-64 pt-16 md:pt-0">
        <Outlet />
      </main>
    </div>
  );
};

export default DashboardLayout;
